/* External */
import { useMemo } from 'react';

/* Hooks */
import useFetchCarousel from './useFetchCarousel';
import useCarouselContents from './useCarouselContents';

/* Utils */
import { EPG_FILTERS_ID, RECENTLY_WATCHED_PARAMS } from '../utils/constants';

export default function useFilterChannelsForYou(isForYou) {
  const { carousel: recentlyWatched, isFetching: isFetchingRecentlyWatched } = useFetchCarousel({
    sourceCarouselId: isForYou ? RECENTLY_WATCHED_PARAMS.sourceCarouselId : '',
    type: RECENTLY_WATCHED_PARAMS.type,
    source: RECENTLY_WATCHED_PARAMS.source,
  });
  const recentlyWatchedChannels = useCarouselContents(recentlyWatched);

  const { carousel: mostWatched, isFetching: isFetchingMostWatched } = useFetchCarousel({
    sourceCarouselId: isForYou ? EPG_FILTERS_ID.MOST_WATCHED : '',
  });
  const mostWatchedChannels = useCarouselContents(mostWatched);

  const channels = useMemo(
    () => recentlyWatchedChannels.toOrderedSet()
      .union(mostWatchedChannels.toOrderedSet()).toList(),
    [mostWatchedChannels, recentlyWatchedChannels],
  );

  return {
    channels,
    isFetching: isFetchingRecentlyWatched || isFetchingMostWatched,
  };
}
